<template>
  <div class="componentWrapper" @click="listenOut">

    <div id="project" :class="'grid grid__item_span-12 p0 m0 project-' + page.colorTheme">

      <!-- add the project header -->
      <ProjectHeader v-bind:page="page" :style="'background-color: ' + page.backgroundColor + ';'"></ProjectHeader>
      <!-- end -->

      <!-- Project Content Wrapper  -->
      <div id="projectContent">

        <!-- lets add in some components -->
        <div v-for="item in page.contentAreas" class="grid grid__item_span-12 p0 m0">
          <div v-for="(item, index) in item.type" class="grid grid__item_span-12 p0 m0">

            <div v-if="item.acf_fc_layout === 'component_paragraph'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.paragraph_bkgd_colour + '; padding:' + item.paragraph_v1_padding + ';'">
               <Paragraph :id="'sec-' + index" :item="item"></Paragraph>
            </div>

            <div v-if="item.acf_fc_layout === 'component_paragraph_v2'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.paragraph_v2_bkgd_colour + '; padding:' + item.paragraph_v2_padding + ';'">
               <Paragraph2 :id="'sec-' + index" :item="item"></Paragraph2>
            </div>

            <div v-if="item.acf_fc_layout === 'component_headline'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.headline_bkgd_colour + '; padding:' + item.headline_padding + ';'">
              <Headline :id="'sec-' + index" :item="item"></Headline>
            </div>

            <div v-if="item.acf_fc_layout === 'component_double_image'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.double_image_bkgd_colour + '; padding:' + item.double_image_padding + ';'">
              <DoubleImage :id="'sec-' + index" :item="item"></DoubleImage>
            </div>

            <div v-if="item.acf_fc_layout === 'component_single_image'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.single_image_bkgd_colour + '; padding:' + item.single_image_padding + ';'">
              <SingleImage :id="'sec-' + index" :item="item"></SingleImage>
            </div>

            <div v-if="item.acf_fc_layout === 'component_video'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.video_bkgd_colour + '; padding:' + item.video_padding + ';'">
              <PageVideo :id="'sec-' + index" :item="item"></PageVideo>
            </div>

            <div v-if="item.acf_fc_layout === 'component_image_slider'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.slider_bkgd_colour + '; padding:' + item.image_slider_padding + ';'">
              <ImageSlider :id="'sec-' + index" :item="item, index"></ImageSlider>
            </div>

            <div v-if="item.acf_fc_layout === 'component_quote'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.quote_bkgd_colour + '; padding:' + item.quote_padding + ';'">
              <Quote :id="'sec-' + index" :item="item"></Quote>
            </div>

          </div>
        </div>
        <!-- end of components -->

      </div>

    </div>

    <!-- <div id="casestudyFooter" class="grid grid__item_span-12 p0 m0" v-in-viewport>
      <div class="inner grid grid__item_span-9" v-for="(item, index) in siblings" v-if="nextPageLink === item.pageLink" :id="item.pageID">
        <p class="txtWhite grid grid__item_span-12 m0 p0">Can't get enough?</p>
        <h2 class="txtWhite grid grid__item_span-12 m0 p0">{{item.pageTitle}}</h2>
        <router-link :to="item.pageLink"><p class="txtWhite grid grid__item_span-12 m0 p0">View some awesome work</p></router-link>
      </div>
    </div> -->


  </div>

</template>

<script>

import menuTransitions from '../assets/js/menu.js'
import ProjectHeader from '../components/project/proj_header.vue'
import ProjectFooter from '../components/project/projectFooter.vue'
import Headline from '../components/project/headline.vue'
import Quote from '../components/project/quote.vue'
import Paragraph from '../components/project/paragraph.vue'
import Paragraph2 from '../components/project/paragraph2.vue'
import SingleImage from '../components/project/singleImage.vue'
import PageVideo from '../components/project/video.vue'
import DoubleImage from '../components/project/doubleImage.vue'
import ImageSlider from '../components/project/imageSlider.vue'
import animateScrollTo from 'animated-scroll-to'
import Axios from 'axios'

export default {
  name: 'Project',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      logoColour: 'black',
      metaTitle: '',
      metaDescription: '',
      page: {},
      siblings: [],
      nav: [],
      nextPageLink: ''
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription }
      ]
    }
  },
  computed: {
    findLogoColour: function () {
      // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    }
  },
  methods: {
    scrollTo (destination) { // scroll to a div position
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    nextPage () {
      // this.navigationDirection = 'forward'
      // console.log(this.nav)
      // console.log(this.$route.params.slug)
      var navLength = this.nav.length - 1
      var currentSlug = this.$route.params.slug
      var nextPage = ''
      var currentPage = this.nav.indexOf(currentSlug)
      if (currentPage === navLength) {
        nextPage = this.nav[0]
      } else {
        nextPage = this.nav[currentPage + 1]
      }
      // console.log(nextPage)
      this.nextPageLink = nextPage
      // if (nextPage) { this.$router.push(nextPage) }
    }
    /* scroller () {
      var d = document.documentElement
      var offset = d.scrollTop + window.innerHeight
      var height = d.offsetHeight - 0.5
      var footerTop = document.getElementById('casestudyFooter').offsetTop - 1
      console.log(footerTop)
      console.log(offset + ', ' + height)
      // if (offset === height || offset >= height) {
      if (footerTop === offset || offset >= footerTop) {
        console.log('at the bottom')
        // this.nextPage()
        // document.getElementById('casestudyFooter').style.position = 'fixed'
        // document.getElementById('casestudyFooter').classList.add('openUp')
      } if (offset <= footerTop) {
        // document.getElementById('casestudyFooter').style.position = 'absolute'
        // document.getElementById('casestudyFooter').classList.remove('openUp')
      }
    } */
  },
  mounted () {
    // Hide the bsdText div until we scroll
    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    // this.$el.addEventListener('wheel', this.scroller, true)

    Axios.get(this.$root.$data.site + '/wp-json/wp/v2/ourwork/').then(response => {
      var siblings = response.data.map(obj => {
        return {
          pageID: obj.id,
          pageTitle: obj.acf.project_title,
          pageClient: obj.acf.client_name,
          cta: obj.acf.project_cta,
          slug: {
            name: 'Project',
            url: obj.slug,
            id: obj.id
          }
        }
      })
      siblings.forEach(el => {
        this.siblings.push(el)
      })

      var nav = response.data.map(obj => obj.slug)

      nav.forEach(el => {
        this.nav.push(el)
      })

      this.nextPage()
    }).catch(function (error) {
      console.log(error)
    })

    Axios.get(this.$root.$data.site + '/wp-json/wp/v2/ourwork/?slug=' + this.$route.params.slug).then(response => {
      this.metaTitle = response.data[0].acf.meta_title
      this.metaDescription = response.data[0].acf.meta_description
      this.logoColour = response.data[0].acf.bsd_logo_colour
      this.postID = response.data[0].id
      var page = {
        colorTheme: response.data[0].acf.colour_theme,
        title: response.data[0].acf.project_title,
        client: response.data[0].acf.client_name,
        textColor: response.data[0].acf.heading_text_colour,
        backgroundColor: response.data[0].acf.background_colour_ourwork,
        headerImageURL: response.data[0].acf.header_image.url,
        headerImageTxt: response.data[0].acf.header_image.alt,
        contentAreas: response.data[0].acf.project_layout.length > 0 ? response.data[0].acf.project_layout.map(obj => {
          return {
            type: obj.components
          }
        }) : null
      }

      this.page = page
    }).catch(function (error) {
      console.log(error)
    })
  },
  components: {
    ProjectHeader,
    ProjectFooter,
    Headline,
    Quote,
    Paragraph,
    Paragraph2,
    SingleImage,
    DoubleImage,
    ImageSlider,
    PageVideo
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .componentWrapper{
    /* padding: 15vh 0; */
    /* background: #EFF0F1; */
  }

</style>



// WEBPACK FOOTER //
// src/components/work.vue